import React from "react";
import "../../../../../css/games/funMatka/title.css" 
import funMatka from "../../../../../../assets/titles/indie/matka.svg";

export default function Title(props){
    return<div className="fd text-center matkaTitle_portrait">
    <img className='matkaNonTimerTitle' src={funMatka} alt={funMatka}></img>
    </div>
}